import { graphql } from '@search/gql-client/src';

export const OfferNearestMapQuery = graphql`query OfferNearestMapQuery(
    $filters: SearchOffersMapByOfferInput!
) {
    searchOffersMapByOffer(filters: $filters) {
        tileUrl
        points {
            __typename
            ... on MultiOfferPointFlat {
                id
                addressId
                geoHash
                count
                isNewBuilding
                coordinates {
                    latitude
                    longitude
                }
                minPriceRub
                minPrice {
                    value
                    currency
                    areaUnit
                }
                minArea {
                    unit
                    value
                }
                maxArea {
                    unit
                    value
                }
                hasHighlight
            }
            ... on MultiOfferPointRoom {
                id
                addressId
                geoHash
                count
                coordinates {
                    latitude
                    longitude
                }
                minPriceRub
                minPrice {
                    value
                    currency
                    areaUnit
                }
                minArea {
                    unit
                    value
                }
                maxArea {
                    unit
                    value
                }
                hasHighlight
            }
            ... on MultiOfferPointHouse {
                id
                addressId
                geoHash
                count
                coordinates {
                    latitude
                    longitude
                }
                minPriceRub
                minPrice {
                    value
                    currency
                    areaUnit
                }
                minArea {
                    unit
                    value
                }
                maxArea {
                    unit
                    value
                }
                hasHighlight
            }
            ... on MultiOfferPointLand {
                id
                addressId
                geoHash
                count
                coordinates {
                    latitude
                    longitude
                }
                minPriceRub
                minPrice {
                    value
                    currency
                    areaUnit
                }
                minArea {
                    unit
                    value
                }
                maxArea {
                    unit
                    value
                }
                hasHighlight
            }
            ... on SingleOfferPointFlat {
                offer {
                    id
                    isFavorite
                    location {
                        narrowRegion {
                            id
                        }
                        coordinates {
                            latitude
                            longitude
                        }
                    }
                    dealType {
                        __typename
                        ... on ProfOfferDealSell {
                            price {
                                value
                                rubPrice
                                currency
                                areaUnit
                                history {
                                    valueRub
                                    diff {
                                        rub
                                    }
                                    date2 {
                                        iso
                                        formattedAutoDate
                                    }
                                }
                            }
                        }
                        ... on ProfOfferDealRent {
                            utilities {
                                has
                            }
                            price {
                                value
                                rubPrice
                                currency
                                areaUnit
                                history {
                                    valueRub
                                    diff {
                                        rub
                                    }
                                    date2 {
                                        iso
                                        formattedAutoDate
                                    }
                                }
                            }
                        }
                    }
                    gallery {
                        mainImage {
                            medium
                            preview1
                        }
                        images {
                            medium
                            preview1
                        }
                    }
                    realtyObject {
                        __typename
                        ... on ProfOfferFlat {
                            roomType
                            building {
                                isNewbuilding
                                floorsTotal
                            }
                            characteristics {
                                floor
                            }
                            totalArea {
                                value
                                unit
                            }
                        }
                    }
                    seller {
                        sellerType
                    }
                    status {
                        hasAnyPriority
                        hasHighlight
                    }
                }
            }

            ... on SingleOfferPointRoom {
                offer {
                    id
                    isFavorite
                    location {
                        narrowRegion {
                            id
                        }
                        coordinates {
                            latitude
                            longitude
                        }
                    }
                    dealType {
                        __typename
                        ... on ProfOfferDealSell {
                            price {
                                value
                                rubPrice
                                currency
                                areaUnit
                                history {
                                    valueRub
                                    diff {
                                        rub
                                    }
                                    date2 {
                                        iso
                                        formattedAutoDate
                                    }
                                }
                            }
                        }
                        ... on ProfOfferDealRent {
                            utilities {
                                has
                            }
                            price {
                                value
                                rubPrice
                                currency
                                areaUnit
                                history {
                                    valueRub
                                    diff {
                                        rub
                                    }
                                    date2 {
                                        iso
                                        formattedAutoDate
                                    }
                                }
                            }
                        }
                    }
                    gallery {
                        mainImage {
                            preview1
                        }
                        images {
                            preview1
                        }
                    }
                    realtyObject {
                        __typename
                        ... on ProfOfferRoom {
                            livingArea {
                                value
                                unit
                            }
                            enclosingFlat {
                                floor
                                building {
                                    isNewbuilding
                                    floorsTotal
                                }
                            }
                        }
                    }
                    seller {
                        sellerType
                    }
                    status {
                        hasAnyPriority
                        hasHighlight
                    }
                }
            }

            ... on SingleOfferPointHouse {
                offer {
                    id
                    isFavorite
                    location {
                        narrowRegion {
                            id
                        }
                        coordinates {
                            latitude
                            longitude
                        }
                    }
                    dealType {
                        __typename
                        ... on ProfOfferDealSell {
                            price {
                                value
                                rubPrice
                                currency
                                areaUnit
                                history {
                                    valueRub
                                    diff {
                                        rub
                                    }
                                    date2 {
                                        iso
                                        formattedAutoDate
                                    }
                                }
                            }
                        }
                        ... on ProfOfferDealRent {
                            utilities {
                                has
                            }
                            price {
                                value
                                rubPrice
                                currency
                                areaUnit
                                history {
                                    valueRub
                                    diff {
                                        rub
                                    }
                                    date2 {
                                        iso
                                        formattedAutoDate
                                    }
                                }
                            }
                        }
                    }
                    gallery {
                        mainImage {
                            preview1
                        }
                        images {
                            preview1
                        }
                    }
                    realtyObject {
                        __typename
                        ... on ProfOfferHouse {
                            totalArea {
                                value
                                unit
                            }
                            land {
                                area {
                                    value
                                    unit
                                }
                            }
                        }
                    }
                    seller {
                        sellerType
                    }
                    status {
                        hasAnyPriority
                        hasHighlight
                    }
                }
            }

            ... on SingleOfferPointLand {
                offer {
                    id
                    isFavorite
                    location {
                        narrowRegion {
                            id
                        }
                        coordinates {
                            latitude
                            longitude
                        }
                    }
                    dealType {
                        __typename
                        ... on ProfOfferDealSell {
                            price {
                                value
                                rubPrice
                                currency
                                areaUnit
                                history {
                                    valueRub
                                    diff {
                                        rub
                                    }
                                    date2 {
                                        iso
                                        formattedAutoDate
                                    }
                                }
                            }
                        }
                        ... on ProfOfferDealRent {
                            utilities {
                                has
                            }
                            price {
                                value
                                rubPrice
                                currency
                                areaUnit
                                history {
                                    valueRub
                                    diff {
                                        rub
                                    }
                                    date2 {
                                        iso
                                        formattedAutoDate
                                    }
                                }
                            }
                        }
                    }
                    gallery {
                        mainImage {
                            preview1
                        }
                        images {
                            preview1
                        }
                    }
                    realtyObject {
                        __typename
                        ... on ProfOfferLand {
                            area {
                                value
                                unit
                            }
                        }
                    }
                    seller {
                        sellerType
                    }
                    status {
                        hasAnyPriority
                        hasHighlight
                    }
                }
            }
        }
    }
}
`;
